import { Table, Text } from '@radix-ui/themes'
import type { Ops } from '@willie/schemas'

interface SkuLinesTableProps {
  lines: readonly Ops.InstallationProfileSkus.SkuLine[]
}

export const MissingArticleCode = () => (
  <Text size="1" color="orange">
    Missing, sent by name
  </Text>
)

export const SkuLinesTable = ({ lines }: SkuLinesTableProps) => (
  <Table.Root size="1" variant="ghost">
    <Table.Header>
      <Table.Row>
        <Table.ColumnHeaderCell>SKU</Table.ColumnHeaderCell>
        <Table.ColumnHeaderCell>Article code</Table.ColumnHeaderCell>
        <Table.ColumnHeaderCell>Client label</Table.ColumnHeaderCell>
        <Table.ColumnHeaderCell justify="end">Qty</Table.ColumnHeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {lines.map((line) => (
        <Table.Row key={line.sku}>
          <Table.Cell>
            <Text size="1">{line.sku}</Text>
          </Table.Cell>
          <Table.Cell>
            {line.articleCode ? (
              <Text size="1" className="font-mono">
                {line.articleCode}
              </Text>
            ) : (
              <MissingArticleCode />
            )}
          </Table.Cell>
          <Table.Cell>
            <Text size="1" color="gray">
              {line.clientLabel}
            </Text>
          </Table.Cell>
          <Table.Cell justify="end">
            <Text size="1">{line.quantity}</Text>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table.Root>
)
